export default "__VITE_ASSET__OQ22zLLI__"